// 实训中心
import {
  textClassify1,
  textClassify2,
  textClassify3,
  textClassify4,
  textClassify5,
  textClassify6,
  textClassify7,
  textClassify8,
  textClassify8_1,
  textClassify9,
  textClassify10,
  textClassify11,
  textClassify12,
  textClassify13,
} from '@/utils/images.js'

const primaryGuide = [
  {
    rightnavs: '文本分类',
    title: '第一步：创建数据集',
    content: '',
    note: '',
    level: 1,
    id:'guide-1',
    children: [
      {
        id:'guide-1-1',
        level: 2,
        content:
          '1、选择模型类型：点击模型类型下拉列表，选择“文本分类”类型，进入文本分类模型页面。',
        note: '',
        imgUrlList: [
          {
            url: textClassify1,
            label: '',
          },
        ],
      },
      {
        id:'guide-1-2',
        level: 2,
        content:
          '2、创建数据集：点击“创建数据集”按钮，弹出数据集创建弹框界面，输入数据集名称、描述，完成数据集创建。',
        note: '',
        imgUrlList: [
          {
            url: textClassify2,
            label: '',
            display: '',
          },
        ],
      },
    ],
  },
  {
    id:'guide-2',
    level: 1,
    title: '第二步：文本分类',
    content: '',
    note: '',
    children: [
      {
        id:'guide-2-1',
        level: 2,
        content:
          '1、添加标签：点击“文本分类”，进入文本分类界面，选择数据集及版本号后，点击 + 符号按钮，添加标签。',
        note: '',
        imgUrlList: [
          {
            url: textClassify3,
            label: '',
            display: '',
          },
        ],
      },
      {
        id:'guide-2-2',
        level: 2,
        note: '',
        content: '2、上传文本：选中对应的标签后，点击“上传文本”，按照上传说明从本地将文本上传。',
        imgUrlList: [
          {
            url: textClassify4,
            label: '',
            display: '',
          },
        ],
      },
      {
        id:'guide-2-3',
        level: 2,
        content:
          '3、发布数据集：完成文本上传后，数据集状态变为“准备就绪”，此时可点击“发布”将该版本数据集发布。',
        imgUrlList: [
          {
            url: textClassify5,
            label: '',
            display: '',
          },
        ],
      },
    ],
  },
  {
    id:'guide-3',
    level: 1,
    title: '第三步：创建模型',
    content: '',
    note: '',
    children: [
      {
        id:'guide-3-1',
        level: 2,
        content:
          '1、点击“创建模型”按钮，在创建模型弹框页面，输入模型名称、模型描述，点击“确定”，完成模型创建。',
        note: '',
        imgUrlList: [
          {
            url: textClassify6,
            label: '',
            display: '',
          },
        ],
      },
    ],
  },
  {
    id:'guide-4',
    level: 1,
    title: '第四步：训练模型',
    content: '',
    note: '',
    children: [
      {
        id:'guide-4-1',
        level: 2,
        content:
          '1、点击“训练模型”按钮，进入训练模型界面，选择训练的模型、模型数据及版本号，勾选需要训练的模型标签后，开始训练。',
        note: '',
        imgUrlList: [
          {
            url: textClassify7,
            label: '',
            display: '',
          },
        ],
      },
      {
        id:'guide-4-2',
        level: 2,
        content:
          '2、查看模型训练进度：点击“我的模型”，进入我的模型页面，选择模型-版本数，进入该模型的版本详情页面。',
        note: '',
        imgUrlList: [
          {
            url: textClassify8,
            label: '',
            display: '',
          },
          // {
          //   url: textClassify8_1,
          //   label: '',
          //   display: '',
          // },
        ],
      },
      {
        id:'guide-4-3',
        level: 2,
        content: '当模型完成训练后，版本模型状态为“训练完成”。',
        note: [
          '①评估报告：显示该版本模型的总体性能，作为评估模型的一个参考指标。',
          '②下载模型：模型状态为“训练完成后”可点击“下载模型”，将模型下载至本地。',
        ],
        imgUrlList: [
          {
            url: textClassify9,
            label: '',
            display: '',
          },
        ],
      },
    ],
  },
  {
    id:'guide-5',
    level: 1,
    title: '第五步：校验模型',
    content: '',
    note: '',
    children: [
      {
        id:'guide-5-1',
        level: 2,
        content:
          '1、点击“校验模型”按钮，进入模型校验页面，选择校验的模型、模型版本；点击“上传文本”，完成校验文本上传； 点击“开始校验”，进行模型校验。',
        note: '',
        imgUrlList: [
          {
            url: textClassify10,
            label: '',
            display: '',
          },
        ],
      },
      {
        id:'guide-5-2',
        level: 2,
        content: '2、输出校验结果。',
        note: '',
        imgUrlList: [
          {
            url: textClassify11,
            label: '',
            display: '',
          },
        ],
      },
    ],
  },
  {
    id:'guide-6',
    level: 1,
    title: '第六步：发布模型',
    content: '',
    note: '',
    children: [
      {
        id:'guide-6-1',
        level: 2,
        content:
          '1、点击左侧“发布模型”按钮，选择发布的模型、版本号；点击“发布模型”，完成模型发布。',
        note: '',
        imgUrlList: [
          {
            url: textClassify12,
            label: '',
            display: '',
          },
        ],
      },
      {
        id:'guide-6-2',
        level: 2,
        content: '2、在“我的模型”，查看模型状态更改为“已发布”。',
        note: '',
        imgUrlList: [
          {
            url: textClassify13,
            label: '',
            display: '',
          },
        ],
      },
    ],
  },
  {
    level: 1,
    footer: '关于模型训练模块的更多功能操作，可查看完整版用户手册了解哦～',
  },
]

//附件
const secodeGuide = []

export default {
  primaryGuide,
  secodeGuide,
}
